export const StringHelper = {
	isJSON: function(value): boolean {
		try {
			return (JSON.parse(value) && !!value);
		} catch (e) {
			return false;
		}
	},
};